<template>
  <SoPageWithHeader title="User List">
    <AdminUserListTable />
  </SoPageWithHeader>
</template>

<script lang="ts">
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import { defineComponent } from "vue"
  import AdminUserListTable from "@/views/admin/users/components/AdminUserListTable.vue"

  export default defineComponent({
    components: {
      AdminUserListTable,
      SoPageWithHeader,
    },
  })
</script>
